import { StringWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-time-widget',
  templateUrl: './time.widget.html'
})
export class MyTimeWidgetComponent extends StringWidget {


}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/time/time.widget.ts